import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=76959b5c&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./style.css?vue&type=style&index=0&id=76959b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76959b5c",
  null
  
)

export default component.exports